<div class="inset-divider"></div>
<div class="ordered-article-line">
  <div class="item" [ngClass]="{ 'item--showOptions': showOptions, 'selected': articleLine?.quantity > 0 }">
    <div class="main-content">
      <itl-info-box *ngIf="showError" class="required-fields-missing-info-box" [type]="InfoBoxType.Error"
        >{{'crossTherapy.document.requiredFieldMissing' | translate}}</itl-info-box
      >
      <div class="row">
        <div class="item-iconwrapper">
          <ion-icon name="alberta-article"></ion-icon>
        </div>
        <div class="content">
          <div class="currentAmount bold">
            {{ articleLine?.quantity }} {{ articleLine?.packagingUnit?.unit | articleUnitPipe }} ({{
            articleLine?.packagingUnit?.quantity }} {{ 'order.edit.unit' | translate }})
          </div>
          <div class="articleInfo">
            <div class="cards-container">
              <itl-card [header]="'order.edit.manufacturerNumber' | translate">
                {{ articleLine?.articleManufacturerNumber }}
              </itl-card>
              <itl-card [header]="'order.edit.customerNumber' | translate">
                {{ articleLine?.articleCustomerNumber }}
              </itl-card>
              <itl-card [header]="'order.edit.articleType' | translate">
                {{ articleLine?.articleInventoryType | articleInventoryTypePipe }}
              </itl-card>
              <itl-card header="Therapie" *ngIf="articleLine.therapyId">
                {{ articleLine.therapyId | therapy }}
              </itl-card>
              <itl-card header="Therapieart" *ngIf="articleLine.therapyTypeId">
                {{ articleLine.therapyTypeId ? (articleLine.therapyTypeId | therapyType) : 'ohne Therapieart' }}
              </itl-card>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="icon">
          <itl-detail-title-therapy-icon
            *ngIf="articleLine.therapyId"
            [therapyId]="articleLine.therapyId"
          ></itl-detail-title-therapy-icon>
        </div>
        <div class="article">
          <div class="articleName bold">{{ articleLine?.articleName }}</div>
          <div class="articleDescription">
            {{ articleLine?.articleDescription }}
            <div *ngIf="articleLine?.article && articleLine?.article?.additionalDescription">
              {{ articleLine?.article?.additionalDescription }}
            </div>
          </div>
          <button (click)="showDetails = !showDetails" class="show-details-button">
            <ion-icon *ngIf="!showDetails" name="chevron-down-outline"></ion-icon>
            <ion-icon *ngIf="showDetails" name="chevron-up-outline"></ion-icon>
          </button>
          <div
            *ngIf="showDetails && (articleLine.storageLocation || articleLine.article.requiresBatchnumber || articleLine.article.requiresSerialnumber)"
            class="details"
          >
            <div class="scanIcon">
              <ion-icon name="alberta-scan"></ion-icon>
            </div>
            <div>
              <div
                *ngIf="showIdentificationNumbers && (articleLine.article.requiresSerialnumber || articleLine.serialNumber)"
                class="description"
              >
                {{'crossTherapy.document.serialNumber' | translate}}:
                <span class="bold">{{ articleLine.serialNumber }}</span>
              </div>
              <div *ngIf="showIdentificationNumbers && articleLine.operatingHours" class="description">
                {{'crossTherapy.document.operatingHours' | translate}}:
                <span class="bold">{{ articleLine.operatingHours }}</span>
              </div>
              <div
                *ngIf="showIdentificationNumbers && articleLine.article.requiresBatchnumber || articleLine.batchNumber"
                class="description"
              >
                {{'crossTherapy.document.batchNumber' | translate}}:
                <span class="bold">{{ articleLine.batchNumber }}</span>
              </div>
              <div *ngIf="articleLine.storageLocation" class="description">
                {{'crossTherapy.document.storageLocation' | translate}}:
                <div class="bold">{{ articleLine.storageLocation }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="show-options-button" (click)="showOptions = !showOptions">
      <ion-icon *ngIf="!showOptions" name="arrow-back"></ion-icon>
      <ion-icon *ngIf="showOptions" name="arrow-forward"></ion-icon>
    </button>
  </div>
  <div *ngIf="showOptions" class="actionArea">
    <itl-cross-therapy-document-article-data
      [articleLine]="articleLine"
      [patient]="patient"
      [showScanButtons]="showScanButtons"
      [showStorageLocation]="node.options?.showStorageLocation ? true : false"
      [showIdentificationNumbers]="showIdentificationNumbers"
    ></itl-cross-therapy-document-article-data>
  </div>
</div>
<div class="inset-divider"></div>
